/* Liz Campos — barra fija de compra en celular (oct 2026) */
(function () {
  function init() {
    if (!/\/products\//.test(location.pathname)) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var anchor = info.querySelector('.product-form__buttons') || info.querySelector('product-form');
    if (!anchor) return;

    function visibleSubmit() {
      var list = info.querySelectorAll('product-form button, form[action*="/cart/add"] button');
      for (var i = 0; i < list.length; i++) {
        var b = list[i];
        if (b.offsetParent !== null && !/shopify-payment|quick-add|quantity__button/.test(b.className) && b.textContent.trim()) return b;
      }
      return null;
    }

    var title = info.querySelector('.product__title h1') || info.querySelector('.product__title');
    var bar = document.createElement('div');
    bar.className = 'lc-sticky';
    bar.innerHTML = '<div class="lc-sticky__info"><div class="lc-sticky__title"></div><div class="lc-sticky__meta"></div></div><button type="button" class="button lc-sticky__btn"></button>';
    bar.querySelector('.lc-sticky__title').textContent = title ? title.textContent.trim() : '';
    document.body.appendChild(bar);
    var btn = bar.querySelector('.lc-sticky__btn');

    function sync() {
      var b = visibleSubmit();
      btn.textContent = b ? b.textContent.replace(/\s+/g, ' ').trim() : 'Ver tallas';
      btn.disabled = b ? b.disabled : false;
      var price = null;
      var items = info.querySelectorAll('.price .price-item');
      for (var i = 0; i < items.length; i++) { if (items[i].offsetParent !== null && items[i].textContent.trim()) { price = items[i]; break; } }
      var size = info.querySelector('variant-radios input:checked');
      bar.querySelector('.lc-sticky__meta').textContent = [price && price.textContent.trim(), size && ('Talla ' + size.value)].filter(Boolean).join(' · ');
    }

    sync();

    btn.addEventListener('click', function () {
      var b = visibleSubmit();
      if (b && !b.disabled) b.click();
      else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show) sync();
      bar.classList.toggle('is-visible', show);
    }).observe(anchor);

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(sync, 700);
    });
  }
  function clampCollection() {
    var d = document.querySelector('.collection-hero__description');
    if (!d || !window.matchMedia('(max-width: 749px)').matches) return;
    d.classList.add('lc-clamp');
    if (d.scrollHeight <= d.clientHeight + 4) { d.classList.remove('lc-clamp'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lc-more'; b.textContent = 'Leer más';
    b.addEventListener('click', function () {
      var open = d.classList.toggle('lc-clamp') === false;
      b.textContent = open ? 'Leer menos' : 'Leer más';
    });
    d.parentNode.insertBefore(b, d.nextSibling);
  }
  /* Carrito: estado de cada pieza + confianza junto al botón de pago */
  var WA = 'https://wa.me/529211336262?text=' + encodeURIComponent('Hola, tengo una duda antes de pagar mi carrito');
  var TRUST = '<ul class="lc-cart-trust">' +
    '<li>Envío gratis a todo México</li>' +
    '<li>Cambios de talla en línea hasta 7 días después de recibir</li>' +
    '<li>Tarjeta, PayPal o en quincenas con Kueski Pay y Aplazo</li>' +
    '</ul><p class="lc-cart-help">¿Dudas antes de pagar? <a href="' + WA + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a></p>';
  var busy = false, timer = null;
  function cartItems() { return document.querySelectorAll('cart-drawer .cart-item, #main-cart-items .cart-item'); }
  function needsWork() {
    var items = cartItems();
    for (var i = 0; i < items.length; i++) if (!items[i].querySelector('.lc-cart-status')) return true;
    var ctas = document.querySelectorAll('cart-drawer .cart__ctas, .cart__footer .cart__ctas');
    for (var j = 0; j < ctas.length; j++) if (!ctas[j].parentNode.querySelector('.lc-cart-trust')) return true;
    return false;
  }
  function decorateCart() {
    if (busy || !needsWork()) return;
    busy = true;
    document.querySelectorAll('cart-drawer .cart__ctas, .cart__footer .cart__ctas').forEach(function (c) {
      if (c.parentNode.querySelector('.lc-cart-trust')) return;
      var w = document.createElement('div'); w.className = 'lc-cart-reassure'; w.innerHTML = TRUST;
      c.parentNode.insertBefore(w, c.nextSibling);
    });
    if (!cartItems().length) { busy = false; return; }
    fetch('/?sections=lc-cart-meta', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var m = /<script[^>]*id="lc-cart-meta-data"[^>]*>([\s\S]*?)<\/script>/.exec(j['lc-cart-meta'] || '');
        var data = m ? JSON.parse(m[1]) : [];
        cartItems().forEach(function (el) {
          var n = parseInt((el.id || '').replace(/\D+/g, ''), 10);
          var d = data[n - 1];
          var host = el.querySelector('.cart-item__details');
          if (!d || !host) return;
          var old = host.querySelector('.lc-cart-status'); if (old) old.remove();
          var p = document.createElement('p');
          p.className = 'lc-cart-status' + (d.pre ? ' lc-cart-status--pre' : '');
          p.textContent = d.pre ? ('Pre order' + (d.eta ? ' · entrega en ' + d.eta : '')) : 'En stock · entrega en 1 a 3 días hábiles';
          host.appendChild(p);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function watchCart() {
    decorateCart();
    ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(decorateCart, 250); })
        .observe(el, { childList: true, subtree: true });
    });
  }
  function boot() { init(); clampCollection(); watchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
